import React, { FC, useEffect, useState } from 'react'

import DownOutlined from '@mui/icons-material/ExpandMore'
import { Dropdown, Menu } from 'antd'
import { useLazyQuery } from '@apollo/client'
import { useRedirect, useStore } from 'react-admin'

import { ACTIVE_MEMBERSHIPS_WITH_ACCOUNTS } from 'shared/gql'
import { Account } from 'shared/types'
import AppState from 'shared/app_state'

export const AccountSwitch: FC = () => {
  const [accountId, setAccountId] = useStore('accountId', AppState.getCurrentAccount()?.id)
  const [accounts, setAccounts] = useState<{ current: Account; others: Account[] }>({ current: null, others: [] })
  const redirect = useRedirect()

  const currentAccount = AppState.getCurrentAccount()
  const currentAccountID = currentAccount ? currentAccount.id : null

  const updateAccounts = ({ allMemberships }) => {
    const accounts: Account[] = allMemberships.map((m) => m.account)
    const current = accounts.find((a) => a.id == currentAccountID)
    const others = current ? accounts.filter((a) => a.id != current.id) : []
    setAccounts({ current, others })
  }

  const [fetchActiveMemberships] = useLazyQuery(ACTIVE_MEMBERSHIPS_WITH_ACCOUNTS, {
    fetchPolicy: 'no-cache',
    onCompleted: updateAccounts,
  })

  useEffect(() => {
    if (currentAccountID)
      fetchActiveMemberships({
        variables: {
          filter: { userId: AppState.getCurrentUser().id, status: 'active' },
        },
      })
  }, [currentAccountID])

  if (!accounts.current) return null

  return (
    <Dropdown
      trigger={['click']}
      placement="bottomRight"
      overlay={
        <Menu>
          <Menu.Item
            onClick={async () => {
              await AppState.updateCurrentAccount({ id: accounts.current.id })
              redirect(`/account/${accounts.current.id}/services/form`)
              setAccountId(accounts.current.id)
            }}
            disabled
          >
            {accounts.current.name}
          </Menu.Item>
          {accounts.others.map((account, i) => (
            <Menu.Item
              key={i}
              onClick={async () => {
                await AppState.updateCurrentAccount({ id: account.id })
                redirect(`/account/${account.id}/services/form`)
                setAccountId(account.id)
              }}
            >
              {account.name}
            </Menu.Item>
          ))}
        </Menu>
      }
      // disabled={accounts.others.length != 0}
    >
      <a
        className="ant-dropdown-linkq"
        style={{
          verticalAlign: 'middle',
          color: 'inherit',
          marginRight: '1rem',
          fontWeight: 600,
        }}
        onClick={(e) => e.preventDefault()}
      >
        {accounts.current.name}
        {/* {accounts.others.length == 0 && ( */}
        <DownOutlined
          style={{
            verticalAlign: 'middle',
          }}
        />
        {/* )} */}
      </a>
    </Dropdown>
  )
}
